export const Property = 1
export const Value = 2
export const Function = 3
export const Variable = 4
export const Keyword = 5
export const Folder = 6
export const File = 7
